import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industries/property-development/page.tsx");
